import { clsx } from 'clsx'
import { type FC } from 'react'

import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { Skeleton } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { gkAirAccessorGetLocalizedProductPharmaForm } from '../../model/gkAirAccessorGetLocalizedProductPharmaForm'
import { gkAirAccessorGetLocalizedProductUnit } from '../../model/gkAirAccessorGetLocalizedProductUnit'

type GkAirProductQuantityProps = {
  className?: string
  product?: GkAirRecommendedProductDataWeb
}

export const GkAirProductQuantity: FC<GkAirProductQuantityProps> = ({
  className,
  product,
}) => {
  const { locale } = useGlobalConfigContext()

  return (
    <span className={clsx('cross-sell-product-card-quantity', className)}>
      {product ? (
        [
          `${Number(product.package_size)} ${gkAirAccessorGetLocalizedProductUnit(
            {
              locale,
              product,
            },
          )}`,
          gkAirAccessorGetLocalizedProductPharmaForm({
            locale,
            product,
          }),
        ]
          .filter(Boolean)
          .join(' | ')
      ) : (
        <Skeleton className="mx-auto w-1/2" />
      )}
    </span>
  )
}
